module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABISURBVBiVpY67EcAgDENfOI2RPbwODOKK6bxHxnCRxtBSoEp3+sItnkXM7M3MCSDJI+ID0DKU2IsDDIB2mtgNkrySSPLr8xs/F2UTPsZPmaAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/saleActive/img_point_black.png
// module id = eXYR
// module chunks = 2